<script>
    import {Listeners} from "../../../constants/listeners";

    export default {
        data() {
            return {
                from: null,
                to: null

            }
        },
        props: {
            item:{
                type: Object,
                required: true

            }
        },
        mounted: function () {
            if(this.item.value){
                let value = this.item.value.split('@');
                this.from = value[0];
                this.to = value[1];
            }
        },
        methods: {
            updateValue: function () {
                // пустую границу отправляем пустой строкой («5@»): сервер трактует её как >= / <=
                const from = this.from ?? '';
                const to = this.to ?? '';
                this.item.value = (from === '' && to === '') ? '' : from + '@' + to;
            },
            submitFormFilter(){
                this.$emitter.emit(Listeners.KS_FILTER_SUBMIT_FORM);
            }
        },
    }
</script>
<template>
    <span>
        <span class="label">от:</span> <input type="number" class="valueinput" v-on:input="updateValue()" v-model.number="from" v-on:keyup.enter="submitFormFilter" />
        <span class="label ml-1">до:</span> <input type="number" class="valueinput" v-on:input="updateValue()" v-model.number="to" v-on:keyup.enter="submitFormFilter"/>
    </span>
</template>
